import {apiAction} from './helper';

export const SET_PLAN_IMG = 'SET_PLAN_IMG';
export const SET_PLAN_IMG_PROPS = 'SET_PLAN_IMG_PROPS';
export const SET_IMG_DRAG = 'SET_IMG_DRAG';
export const UPLOAD_PLAN_IMG = apiAction('UPLOAD_PLAN_IMG');
export const DRAG_PLAN_IMG = 'DRAG_PLAN_IMG';
export const SET_PLAN_IMG_DEFAULT_VIEW = 'SET_PLAN_IMG_DEFAULT_VIEW';
